"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLink = exports.composedLinkStyles = exports.overDarkTheme = exports.standardTheme = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _button = require("../../../styles/2_commonComponentStyles/button");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var standardTheme = (0, _styledComponents.css)(["color:", ";&:visited,&:hover{color:", ";}&:active{color:", ";}&[disabled],&[disabled=\"disabled\"]{color:", ";cursor:not-allowed;&:active,&:visited,&:hover{color:", ";cursor:not-allowed;text-decoration:none;}}}"], function (props) {
  return props.theme.c_clickable_link_default;
}, function (props) {
  return props.theme.c_clickable_link_hover;
}, function (props) {
  return props.theme.c_clickable_link_active;
}, function (props) {
  return props.theme.c_clickable_link_disabled;
}, function (props) {
  return props.theme.c_clickable_link_disabled;
});
exports.standardTheme = standardTheme;
var overDarkTheme = (0, _styledComponents.css)(["color:", ";&,& *{letter-spacing:", ";}&:visited,&:hover{color:", ";}&:active{color:", ";}&[disabled],&[disabled=\"true\"]{color:", ";&:active,&:visited,&:hover{color:", ";}"], function (props) {
  return props.theme.c_clickable_linkOverDark_default;
}, function (props) {
  return props.theme.c_clickable_linkOverDark_default;
}, function (props) {
  return props.theme.c_clickable_linkOverDark_hover;
}, function (props) {
  return props.theme.c_clickable_linkOverDark_active;
}, function (props) {
  return props.theme.c_clickable_linkOverDark_disabled;
}, function (props) {
  return props.theme.c_clickable_linkOverDark_disabled;
});
exports.overDarkTheme = overDarkTheme;
var composedLinkStyles = (0, _styledComponents.css)(["", ";&,& *{letter-spacing:0;}cursor:pointer;display:", ";font-size:1rem;font-weight:", ";width:min-content;text-decoration:none;white-space:nowrap;&:active,&:hover{text-decoration:underline;}&[disabled],&[disabled=\"true\"]{cursor:not-allowed;&:active,&:visited,&:hover{cursor:not-allowed;text-decoration:none;}}", ""], _button.clickable, function (props) {
  return props.isBlock ? 'flex' : 'inline-block';
}, function (props) {
  return props.theme.secondaryHeavy;
}, function (props) {
  return props.overDark ? overDarkTheme : standardTheme;
});
exports.composedLinkStyles = composedLinkStyles;

var StyledLink = _styledComponents.default.a.withConfig({
  displayName: "Linkstyles__StyledLink",
  componentId: "sc-1basjyd-0"
})(["", ""], composedLinkStyles);

exports.StyledLink = StyledLink;